<div class="contact-modal" aria-labelledby="contact-modal-title">
  <h2 id="contact-modal-title" class="modal-title">
    {{ title }}
  </h2>

  <mat-dialog-content class="modal-content">
    <form [formGroup]="form" class="form-container">
      <div class="field-wrapper">
        <label class="field-label" for="contact-type">
          <span class="required">*</span>
          Contact Type
        </label>
        <mat-form-field
          appearance="outline"
          class="field-input field-input-rounded"
        >
          <mat-select
            formControlName="contactType"
            id="contact-type"
            placeholder="Select an option"
          >
            @for (type of types; track type.key) {
              <mat-option [value]="type.value">
                {{ type.value }}
              </mat-option>
            }
          </mat-select>
          @if (errorMessage("contactType")()) {
            <mat-error>{{ errorMessage("contactType")() }}</mat-error>
          }
        </mat-form-field>
      </div>
      <div class="field-wrapper">
        <label class="field-label" for="contact-name">
          <span class="required">*</span>Contact Name
        </label>
        <mat-form-field
          appearance="outline"
          class="field-input field-input-rounded"
        >
          <input matInput formControlName="contactName" id="contact-name" />
          @if (errorMessage("contactName")()) {
            <mat-error>{{ errorMessage("contactName")() }}</mat-error>
          }
        </mat-form-field>
      </div>

      <div class="field-wrapper">
        <label class="field-label" for="contact-email">
          <span class="required">*</span>Contact Email
        </label>
        <mat-form-field
          appearance="outline"
          class="field-input field-input-rounded"
        >
          <input matInput formControlName="contactEmail" id="contact-email" />
          @if (errorMessage("contactEmail")()) {
            <mat-error>{{ errorMessage("contactEmail")() }}</mat-error>
          }
        </mat-form-field>
      </div>

      <div class="field-wrapper">
        <label class="field-label" for="contact-phone"
          >Phone Number (optional)</label
        >
        <mat-form-field
          appearance="outline"
          class="field-input field-input-rounded"
        >
          <input matInput formControlName="contactPhone" id="contact-phone" />
          @if (errorMessage("contactPhone")()) {
            <mat-error>{{ errorMessage("contactPhone")() }}</mat-error>
          }
        </mat-form-field>
      </div>
    </form>
  </mat-dialog-content>

  <mat-dialog-actions class="modal-actions" align="end">
    <button
      mat-button
      (click)="onSave()"
      type="button"
      class="save-button modal-button"
    >
      {{ saveButtonText }}
    </button>
    <button
      mat-button
      (click)="onCancel()"
      type="button"
      class="cancel-button modal-button"
    >
      {{ cancelButtonText }}
    </button>
  </mat-dialog-actions>
</div>
